import "preact/debug"
import { createHashHistory } from "history"
import { render } from "htm/preact"
import Router, { route } from "preact-router"

import { trackEvent } from "../utils/analytics"
import { DisplayOnce, ElfsightPopup, MappedImage, VimeoFrame, Modal, ModalWrapper, Clue, YouTube, SponsorModal } from "../utils/fw"

import { CometChat } from "./components/CometChat"
import { Navbar } from "./components/Navbar"
import { Room } from "./components/Room"

import * as roomSources from "./rooms"
import { Leaderboard } from "./components/Leaderboard"
import { isMember } from "./utils"
import { IBMPopup } from "./components/IBMPopup"
import "./styles.css"


const { "Event ID": eventId, "Registrant ID": regId } = window.dataLayer[0]

const rooms = [
	roomSources.atrium,
	roomSources.breakouts,
	roomSources.breakout1,
	roomSources.breakout2,
	roomSources.breakout3,
	roomSources.breakout4,
	roomSources.engagementSessions,
	roomSources.lounge,
	roomSources.roundTables,
	roomSources.sponsorTheatre,
	{
		background: "https://assets.swoogo.com/uploads/full/1403310-6164ec03b7855.jpg",
		links: [
			{
				label: "Huawei",
				href: "/exhibition-hall-platinum",
				width: "13.4%",
				height: "19.7%",
				left: "27.2%",
				top: "4.4%",
			},
			{
				label: "KPMG",
				href: "/exhibition-hall-diamond",
				width: "15.8%",
				height: "22.2%",
				left: "42.3%",
				top: "2.1%",
			},
			{
				label: "IBM",
				href: "/exhibition-hall-platinum",
				width: "13.3%",
				height: "20.2%",
				left: "60%",
				top: "4.1%",
			},
			...(isMember ?
				[{
					label: "Leaderboard",
					width: "10.1%",
					height: "6.1%",
					left: "86.9%",
					top: "2.6%",
					modal: <ModalWrapper>
						{window.dataLayer[0]["I would like to opt in to the Leaderboard competition"] === "Yes"
							?
							<iframe style="width: 30vw; height: 35vh; border: none;" src={`https://sponsor-gamification.herokuapp.com/leaderboard?eventId=${eventId}&registrantId=${regId}&swoogoAccess=false`} />
							:
							(
								<div style="display: flex; flex-direction: column; justify-content: space-around; width: 650px; height: 130px; color: white;">
									<h1 style="font-size: 28px; margin: 0;">Want to participate in the leaderboard competition?</h1>
									<p style="font-size: 16px;">You are not opted-in to the leaderboard gamification feature. To opt-in, please modify your registration <a href="https://isfcongress.tkeventsregistration.com/digital2021">here.</a>
									</p>
								</div>
							)}
					</ModalWrapper>
				}] : []
			),
			{
				label: "SecurityScorecard",
				href: "/exhibition-hall-gold",
				width: "10.8%",
				height: "16%",
				left: "14.4%",
				top: "24.8%",
			},
			{
				label: "SentinelOne",
				href: "/exhibition-hall-gold",
				width: "10.8%",
				height: "16%",
				left: "26.6%",
				top: "24.8%",
			},
			{
				label: "SureCloud",
				href: "/exhibition-hall-gold",
				width: "10.8%",
				height: "16%",
				left: "38.8%",
				top: "24.8%",
			},
			{
				label: "BitSight",
				href: "/exhibition-hall-gold",
				width: "10.8%",
				height: "16%",
				left: "50.8%",
				top: "24.8%",
			},
			{
				label: "BeyondTrust",
				href: "/exhibition-hall-gold",
				width: "10.8%",
				height: "16%",
				left: "63.2%",
				top: "24.8%",
			},
			{
				label: "CybelAngel",
				href: "/exhibition-hall-gold",
				width: "10.8%",
				height: "16%",
				left: "75.4%",
				top: "24.8%",
			},
			{
				label: "ImmuniWeb",
				href: "/exhibition-hall-silver",
				width: "9.2%",
				height: "14.5%",
				left: "2.6%",
				top: "40.5%",
			},
			{
				label: "Tessian",
				href: "/exhibition-hall-silver",
				width: "9.2%",
				height: "14.5%",
				left: "14.5%",
				top: "40.5%",
			},
			{
				label: "OneTrust Vendorpedia",
				href: "/exhibition-hall-silver",
				width: "9.2%",
				height: "14.5%",
				left: "24.3%",
				top: "40.5%",
			},
			{
				label: "Synopsys",
				href: "/exhibition-hall-silver",
				width: "9.2%",
				height: "14.5%",
				left: "36.4%",
				top: "40.5%",
			},
			{
				label: "Veracode",
				href: "/exhibition-hall-silver",
				width: "9.2%",
				height: "14.5%",
				left: "45.8%",
				top: "40.5%",
			},
			{
				label: "CrowdStrike",
				href: "/exhibition-hall-silver",
				width: "9.2%",
				height: "14.5%",
				left: "55.3%",
				top: "40.5%",
			},
			{
				label: "Keysight",
				href: "/exhibition-hall-silver",
				width: "9.2%",
				height: "14.5%",
				left: "66.8%",
				top: "40.5%",
			},
			{
				label: "Crossword",
				href: "/exhibition-hall-silver",
				width: "9.2%",
				height: "14.5%",
				left: "76.9%",
				top: "40.5%",
			},
			{
				label: "CRMG",
				href: "/exhibition-hall-silver",
				width: "9.2%",
				height: "14.5%",
				left: "88.7%",
				top: "40.5%",
			},
			{
				label: "Passport to Prizes - Instructions",
				width: "16.1%",
				height: "24.6%",
				left: "5.8%",
				top: "57.4%",
				modal: <ModalWrapper>
					<div style="display: flex; flex-direction: column; justify-content: space-evenly; width: 700px; height: 400px; color: white;">
						<h1 style="font-size: 28px; margin: 0;">PASSPORT TO PRIZES - INSTRUCTIONS:</h1>

						<p style="font-size: 16px;">To enter the prize draw, look for nine letters hidden in the participating sponsors’ booths. Look out for the Congress logo!
							Once you have found all the letters, unscramble them to create a word, and submit your answer via the pop-up form in the Exhibition Hall.</p>

						<p style="font-size: 16px;">Please ensure that you have submitted your answer by 18:00 UTC on Wednesday 27 October.</p>

						<p style="font-size: 16px;">Prize draw winners will be notified from Thursday 28 October and all entrants may apply for details of the winning participants by contacting us at <a href="mailto:congress@securityforum.org" target="_blnk">congress@securityforum.org</a></p>

						<p style="font-size: 16px;">Note that entrants must visit all nine hidden locations to be eligible for the prize draw.</p>

						<p style="font-size: 16px;">By submitting your answer you are opting into the Passport to Prizes draw and are consenting to being contacted by a sponsor in connection with sponsored prizes. After the draw sponsors will contact prize winners and will deliver prizes directly to the winner’s address.</p>

						<p style="font-size: 16px;">Full terms and conditions are available <a target="_blnk" href="https://assets.swoogo.com/uploads/1406575-6166d0abbdfc1.pdf">here</a>.</p>
					</div>
				</ModalWrapper>
			},
			{
				label: "Passport to Prizes - Submit Answers",
				width: "16.1%",
				height: "10.5%",
				left: "5.8%",
				top: "82.3%",
				onClick: () => document.getElementById("isf-2021-prize-submit").click()
			},
			{
				label: "Enter Sponsor Theatre",
				href: "/sponsor-theatre",
				width: "17.5%",
				height: "22.9%",
				left: "71.2%",
				top: "56.4%",
			},
			{
				label: "Agenda",
				href: isMember ? "https://isfcongress.tkeventsregistration.com/digital2021/sponsortheatreagenda" : "https://isfcongress.tkeventsregistration.com/digital2021/sponsortheatrenm",
				isExternal: true,
				target: "_blank",
				width: "6.5%",
				height: "7.5%",
				left: "89.6%",
				top: "66.1%",
			},
		],
		name: "exhibition-hall",
	},
	{
		background: "https://assets.swoogo.com/uploads/full/1405341-6165e671986ef.jpg",
		links: [
			...(isMember ? [{
				display: "none",
				label: "Leaderboard",
				modal: <ModalWrapper>
					<iframe style="width: 30vw; height: 35vh; border: none;" src="https://sponsor-gamification.herokuapp.com/leaderboard?eventId=41082&registrantId=10457086&swoogoAccess=false" />
				</ModalWrapper>
			}] : []),
			{
				label: "Previous Room",
				href: "/exhibition-hall-silver",
				width: "17%",
				height: "8.0%",
				left: "23.3%",
				top: "89.0%",
			},
			{
				label: "Next Room",
				href: "/exhibition-hall-platinum",
				width: "17.0%",
				height: "8%",
				left: "58.9%",
				top: "89.6%",
			},
			{
				label: "Back To Main Hall",
				href: "/exhibition-hall",
				width: "18.2%",
				height: "8%",
				left: "40.8%",
				top: "89.3%",
			},
			{
				label: "KPMG Logo",
				gaAction: "KPMG",
				width: "21.6%",
				height: "23.6%",
				left: "71.1%",
				top: "6.1%",
				modal: <SponsorModal sponsorID="181217/kpmg" />,
				modalOverrides: {
					dismissStyle: {
						color: "#3c1d4a",
						fontSize: "27px",
						textDecoration: "none !important",
						top: "30px",
						padding: "10px 20px",
						textAlign: "center"
					},
				}
			},
			{
				gameRule: "exhibition-chat-kpmg",
				label: "Chat With KPMG",
				gaAction: "KPMG",
				width: "5.7%",
				height: "12.5%",
				left: "14.8%",
				top: "39.3%",
				CometChatID: "kpmg",
			},
			{
				gameRule: "exhibition-download-kpmg",
				label: "KPMG - From Enforcer To Influencer",
				gaAction: "KPMG",
				href: "https://assets.swoogo.com/uploads/1407949-616729468ef19.pdf",
				isExternal: true,
				target: "_blank",
				width: "9.3%",
				height: "16.7%",
				left: "24.0%",
				top: "67.2%",
			},
			{
				gameRule: "exhibition-download-kpmg-2",
				label: "KPMG - Human Firewalling",
				gaAction: "KPMG",
				href: "https://assets.swoogo.com/uploads/1407952-616729725ea21.pdf",
				isExternal: true,
				target: "_blank",
				width: "6.1%",
				height: "15.0%",
				left: "46.8%",
				top: "65.1%",
			},
			{
				gameRule: "exhibition-video-kpmg",
				label: "KPMG Video",
				gaAction: "KPMG",
				modal: <VimeoFrame
					vidId="617090363?h=869511cab2&autoplay=1"
				></VimeoFrame>,
				width: "15.2%",
				height: "17.7%",
				left: "74.9%",
				top: "44.4%",
			},
			{
				label: "KPMG Gamification",
				gaAction: "KPMG",
				width: "5.2%",
				height: "8.7%",
				left: "79.9%",
				top: "71.4%",
				modal: <ModalWrapper><Clue
					letter="&quot;K&quot;!"
				></Clue></ModalWrapper>
			}
		],
		name: "exhibition-hall-diamond",
	},
	{
		background: "https://assets.swoogo.com/uploads/full/1405347-6165e6b240143.jpg",
		links: [
			...(isMember ?
				[{
					display: "none",
					label: "Leaderboard",
					modal: <ModalWrapper>
						<iframe style="width: 30vw; height: 35vh; border: none;" src="https://sponsor-gamification.herokuapp.com/leaderboard?eventId=41082&registrantId=10457086&swoogoAccess=false" />
					</ModalWrapper>
				}] : []
			),
			{
				label: "Previous Room",
				href: "/exhibition-hall-diamond",
				width: "17%",
				height: "8%",
				left: "24%",
				top: "89.5%",
			},
			{
				label: "Next Room",
				href: "/exhibition-hall-gold",
				width: "17.0%",
				height: "8%",
				left: "58.9%",
				top: "89.6%",
			},
			{
				label: "Back To Main Hall",
				href: "/exhibition-hall",
				width: "18.2%",
				height: "8%",
				left: "41%",
				top: "89.3%",
			},

			{
				label: "Huawei Technologies Logo",
				gaAction: "Huawei",
				width: "38.6%",
				height: "12.6%",
				left: "7.5%",
				top: "21.4%",
				modal: <SponsorModal sponsorID="181218/huawei-technologies" />,
				modalOverrides: {
					dismissStyle: {
						top: "30px",
						padding: "10px 20px",
					},
				}
			},
			{
				gameRule: "exhibition-video-huawei",
				label: "Huawei Technologies Video",
				gaAction: "Huawei",
				modal: <VimeoFrame
					vidId="617060003?h=d72ed2bd3b&autoplay=1"
				></VimeoFrame>,
				width: "10%",
				height: "11.4%",
				left: "9.4%",
				top: "49%",
			},
			{
				gameRule: "exhibition-chat-huawei",
				label: "Chat With Huawei Technologies",
				gaAction: "Huawei",
				width: "5.4%",
				height: "12.1%",
				left: "44%",
				top: "42.6%",
				CometChatID: "huawei",
			},
			{
				gameRule: "exhibition-download-huawei",
				label: "Transparency Centre Brochure",
				gaAction: "Huawei",
				href: "https://assets.swoogo.com/uploads/1407902-616725076fe2d.pdf",
				target: "_blank",
				width: "10.9%",
				height: "15.4%",
				left: "9.4%",
				top: "60.4%",
			},
			{
				gameRule: "exhibition-download-huawei-2",
				label: "5G Core Audit Report",
				gaAction: "Huawei",
				href: "https://assets.swoogo.com/uploads/1407913-616725f2ba3ef.pdf",
				target: "_blank",
				width: "5.8%",
				height: "12.5%",
				left: "30.2%",
				top: "65.5%",
			},
			{
				label: "Huawei Technologies Gamification",
				gaAction: "Huawei",
				width: "3.8%",
				height: "7.2%",
				left: "36.4%",
				top: "70.1%",
				modal: <ModalWrapper><Clue
					letter="&quot;B&quot;!"
				></Clue></ModalWrapper>
			},
			{
				label: "IBM Logo",
				gaAction: "IBM",
				width: "42.5%",
				height: "10.2%",
				left: "54.6%",
				top: "22.8%",
				modal: <SponsorModal sponsorID="181219/ibm-security" />,
				modalOverrides: {
					dismissStyle: {
						top: "30px",
						padding: "10px 20px",
					},
				}
			},
			{
				gameRule: "exhibition-video-ibm",
				label: "IBM Security Video",
				gaAction: "IBM",
				// href: "https://www.ibm.com/about/be-fearless/",
				// isExternal: true,
				// target: "_blank",
				modal: <VimeoFrame
					vidId="637530622?h=3a62e00a12&autoplay=1"
				></VimeoFrame>,
				width: "10%",
				height: "11%",
				left: "82.6%",
				top: "47.9%",
			},
			{
				gameRule: "exhibition-chat-ibm",
				label: "Chat With IBM Security",
				gaAction: "IBM",
				width: "8.4%",
				height: "15.1%",
				left: "51.0%",
				top: "40.6%",
				CometChatID: "ibm",
			},
			{
				label: "IBM Security Gamification",
				gaAction: "IBM",
				width: "5.8%",
				height: "16.2%",
				left: "62.4%",
				top: "64.1%",
				modal: <ModalWrapper><Clue
					letter="&quot;R&quot; and &quot;H&quot;!"
				></Clue></ModalWrapper>
			},
			{
				gameRule: "exhibition-download-ibm",
				label: "Zero Trust Security",
				gaAction: "IBM",
				href: "https://assets.swoogo.com/uploads/1407932-6167282d284e1.pdf",
				isExternal: true,
				target: "_blank",
				width: "8%",
				height: "13.4%",
				left: "54.2%",
				top: "63.9%",
			},
			{
				gameRule: "exhibition-download-ibm-2",
				label: "Threat Report",
				gaAction: "IBM",
				href: "https://assets.swoogo.com/uploads/1407935-61672842cb68d.pdf",
				isExternal: true,
				target: "_blank",
				width: "8.9%",
				height: "17.7%",
				left: "82.8%",
				top: "59.2%",
			}
		],
		extras: <IBMPopup />,
		name: "exhibition-hall-platinum",
	},
	{
		background: "https://assets.swoogo.com/uploads/full/1405346-6165e6b23fa72.jpg",
		links: [
			...(isMember ?
				[{
					display: "none",
					label: "Leaderboard",
					modal: <ModalWrapper>
						<iframe style="width: 30vw; height: 35vh; border: none;" src="https://sponsor-gamification.herokuapp.com/leaderboard?eventId=41082&registrantId=10457086&swoogoAccess=false" />
					</ModalWrapper>
				}] : []
			),
			{
				label: "Previous Room",
				href: "/exhibition-hall-platinum",
				width: "17%",
				height: "8.0%",
				left: "23.3%",
				top: "89.0%",
			},
			{
				label: "Next Room",
				href: "/exhibition-hall-silver",
				width: "17.0%",
				height: "8%",
				left: "58.9%",
				top: "89.6%",
			},
			{
				label: "Back To Main Hall",
				href: "/exhibition-hall",
				width: "18.2%",
				height: "8%",
				left: "40.8%",
				top: "89.3%",
			},

			{
				label: "SecurityScorecard Logo",
				gaAction: "SecurityScorecard",
				width: "21.4%",
				height: "6.9%",
				left: "11.5%",
				top: "2.7%",
				modal: <SponsorModal sponsorID="181224/securityscorecard" />,
				modalOverrides: {
					dismissStyle: {
						top: "30px",
						padding: "10px 20px",
					},
				}
			},
			{
				gameRule: "exhibition-chat-scorecard",
				label: "Chat With SecurityScorecard",
				gaAction: "SecurityScorecard",
				width: "5.3%",
				height: "9.4%",
				left: "6.2%",
				top: "4.5%",
				CometChatID: "securityscorecard",
			},
			{
				gameRule: "exhibition-video-scorecard",
				label: "SecurityScorecard Video",
				gaAction: "SecurityScorecard",
				modal: <VimeoFrame
					vidId="617094761?h=6818d0621b&autoplay=1"
				></VimeoFrame>,
				width: "6.4%",
				height: "8.1%",
				left: "19.3%",
				top: "12.9%",
			},
			{
				label: "SecurityScorecard Gamification",
				gaAction: "SecurityScorecard",
				width: "6.6%",
				height: "10.6%",
				left: "19.3%",
				top: "23.1%",
				modal: <ModalWrapper><Clue
					letter="&quot;E&quot;!"
				></Clue></ModalWrapper>
			},
			{
				gameRule: "exhibition-download-scorecard",
				label: "Atlas Data Sheet",
				gaAction: "SecurityScorecard",
				href: "https://assets.swoogo.com/uploads/1407795-6167213ccbd60.pdf",
				isExternal: true,
				target: "_blank",
				width: "9.3%",
				height: "11.4%",
				left: "9.8%",
				top: "24.6%",
			},
			{
				gameRule: "exhibition-download-scorecard-2",
				label: "Ratings Data Sheet",
				gaAction: "SecurityScorecard",
				href: "https://assets.swoogo.com/uploads/1407798-6167215d96c14.pdf",
				isExternal: true,
				target: "_blank",
				width: "5%",
				height: "10.6%",
				left: "28.7%",
				top: "25%",
			},
			{
				label: "BeyondTrust Logo",
				gaAction: "BeyondTrust",
				width: "20.9%",
				height: "7.8%",
				left: "39.6%",
				top: "2.8%",
				modal: <SponsorModal sponsorID="181223/beyondtrust" />,
				modalOverrides: {
					dismissStyle: {
						top: "30px",
						padding: "10px 20px",
					},
				}
			},
			{
				gameRule: "exhibition-chat-beyondtrust",
				label: "Chat With BeyondTrust",
				gaAction: "BeyondTrust",
				width: "4.7%",
				height: "10.2%",
				left: "35%",
				top: "4.9%",
				CometChatUserID: "12448627",
			},
			{
				label: "BeyondTrust Gamification",
				gaAction: "BeyondTrust",
				width: "5.6%",
				height: "10.9%",
				left: "48.2%",
				top: "23.5%",
				modal: <ModalWrapper><Clue
					letter="&quot;A&quot;!"
				></Clue></ModalWrapper>
			},
			{
				gameRule: "exhibition-video-beyondtrust",
				label: "BeyondTrust Video",
				gaAction: "BeyondTrust",
				modal: <VimeoFrame
					vidId="617043083?h=89436136b6&autoplay=1"
				></VimeoFrame>,
				width: "6.3%",
				height: "7.7%",
				left: "46.9%",
				top: "12.9%",
			},
			{
				gameRule: "exhibition-download-beyondtrust",
				label: "5 Critical Endpoint Security Steps",
				gaAction: "BeyondTrust",
				href: "https://assets.swoogo.com/uploads/1407805-616721a114d78.pdf",
				isExternal: true,
				target: "_blank",
				width: "8.7%",
				height: "11.2%",
				left: "38.5%",
				top: "24.6%",
			},
			{
				gameRule: "exhibition-download-beyondtrust-2",
				label: "Universal Privilege Management",
				gaAction: "BeyondTrust",
				href: "https://assets.swoogo.com/uploads/1407808-616721d080dfb.pdf",
				isExternal: true,
				target: "_blank",
				width: "5.3%",
				height: "11.2%",
				left: "56.5%",
				top: "24.6%",
			},
			{
				label: "CybelAngel Logo",
				gaAction: "CybelAngel",
				width: "21%",
				height: "8.4%",
				left: "67.3%",
				top: "2.1%",
				modal: <SponsorModal sponsorID="181225/cybelangel" />,
				modalOverrides: {
					dismissStyle: {
						top: "30px",
						padding: "10px 20px",
					},
				}
			},
			{
				gameRule: "exhibition-chat-cybel",
				label: "Chat With CybelAngel",
				gaAction: "CybelAngel",
				width: "4.5%",
				height: "10.6%",
				left: "62.8%",
				top: "5.4%",
				CometChatID: "cybelangel",
			},
			{
				gameRule: "exhibition-video-cybel",
				label: "CybelAngel Video",
				gaAction: "CybelAngel",
				modal: <VimeoFrame
					vidId="617056860?h=ec60827d91&autoplay=1"
				></VimeoFrame>,
				width: "6.9%",
				height: "8.4%",
				left: "74.1%",
				top: "12.6%",
			},
			{
				label: "CybelAngel Gamification",
				gaAction: "CybelAngel",
				width: "6%",
				height: "10.1%",
				left: "76.1%",
				top: "23.8%",
				modal: <ModalWrapper><Clue
					letter="&quot;N&quot;"
				></Clue></ModalWrapper>
			},
			{
				gameRule: "exhibition-download-cybel",
				label: "Guide To Ransomware",
				gaAction: "CybelAngel",
				href: "https://assets.swoogo.com/uploads/1407824-6167228bdc22f.pdf",
				isExternal: true,
				target: "_blank",
				width: "8.7%",
				height: "11.6%",
				left: "66.6%",
				top: "24%",
			},
			{
				gameRule: "exhibition-download-cybel-2",
				label: "Executive Overview",
				gaAction: "CybelAngel",
				href: "https://assets.swoogo.com/uploads/1407848-616723847326e.pdf",
				isExternal: true,
				target: "_blank",
				width: "5.5%",
				height: "11.3%",
				left: "85.1%",
				top: "25%",
			},
			{
				label: "BitSight Logo",
				gaAction: "BitSight",
				width: "21.9%",
				height: "10.1%",
				left: "10.5%",
				top: "42%",
				modal: <SponsorModal sponsorID="181221/bitsight" />,
				modalOverrides: {
					dismissStyle: {
						top: "30px",
						padding: "10px 20px",
					},
				}
			},
			{
				gameRule: "exhibition-chat-bitsight",
				label: "Chat With BitSight",
				gaAction: "BitSight",
				width: "4.7%",
				height: "9.3%",
				left: "5.5%",
				top: "46.7%",
				CometChatID: "bitsight",
			},
			{
				gameRule: "exhibition-video-bitsight",
				label: "BitSight Video",
				gaAction: "BitSight",
				modal: <VimeoFrame
					vidId="617106953?h=01b761c305&autoplay=1"
				></VimeoFrame>,
				width: "6.8%",
				height: "8.5%",
				left: "18.6%",
				top: "52.1%",
			},
			{
				gameRule: "exhibition-download-bitsight",
				label: "TPRM Solution Brief",
				gaAction: "BitSight",
				href: "https://assets.swoogo.com/uploads/1407860-616723c346ae4.pdf",
				isExternal: true,
				target: "_blank",
				width: "9.2%",
				height: "12.2%",
				left: "9%",
				top: "67.1%",
			},
			{
				gameRule: "exhibition-download-bitsight-2",
				label: "Security Ratings",
				gaAction: "BitSight",
				href: "https://assets.swoogo.com/uploads/1407867-616723eacaa2e.pdf",
				isExternal: true,
				target: "_blank",
				width: "5.2%",
				height: "11.7%",
				left: "28.2%",
				top: "66.7%",
			},
			{
				gameRule: "exhibition-surecloud-chat",
				label: "Chat With SureCloud",
				gaAction: "SureCloud",
				width: "4.2%",
				height: "9.8%",
				left: "35.6%",
				top: "46.3%",
				CometChatID: "surecloud",
			},
			{
				label: "SureCloud Logo",
				gaAction: "SureCloud",
				width: "20.2%",
				height: "7.6%",
				left: "39.8%",
				top: "41.3%",
				modal: <SponsorModal sponsorID="181220/surecloud" />,
				modalOverrides: {
					dismissStyle: {
						top: "30px",
						padding: "10px 20px",
					},
				}
			},
			{
				gameRule: "exhibition-video-surecloud",
				label: "SureCloud Video",
				gaAction: "SureCloud",
				modal: <VimeoFrame
					vidId="617098337?h=f714fbef1d&autoplay=1"
				></VimeoFrame>,
				width: "6.1%",
				height: "7.3%",
				left: "42.7%",
				top: "52.2%",
			},
			{
				label: "SureCloud Gamification",
				gaAction: "SureCloud",
				width: "5.8%",
				height: "10.5%",
				left: "47.6%",
				top: "61.6%",
				modal: <ModalWrapper><Clue
					letter="&quot;C&quot;!"
				></Clue></ModalWrapper>
			},
			{
				gameRule: "exhibition-download-contenthub",
				label: "Content Hub",
				gaAction: "SureCloud",
				href: "https://hub.surecloud.com/digital-2021-isf-world-congress",
				isExternal: true,
				target: "_blank",
				width: "8.3%",
				height: "11.8%",
				left: "38.6%",
				top: "65.7%",
			},
			{
				label: "SentinelOne Logo",
				gaAction: "SentinelOne",
				width: "8.9%",
				height: "11.8%",
				left: "67.4%",
				top: "41.4%",
				modal: <SponsorModal sponsorID="181222/sentinelone" />,
				modalOverrides: {
					dismissStyle: {
						top: "30px",
						padding: "10px 20px",
					},
				}
			},
			{
				label: "SentinelOne Gamification",
				gaAction: "SentinelOne",
				width: "4.7%",
				height: "9.6%",
				left: "77.4%",
				top: "63.6%",
				modal: <ModalWrapper><Clue
					letter="&quot;M&quot;!"
				></Clue></ModalWrapper>
			},
			{
				gameRule: "exhibition-video-sentinel",
				label: "SentinelOne Video",
				gaAction: "SentinelOne",
				modal: <VimeoFrame
					vidId="617097068?h=b97333c69a&autoplay=1"
				></VimeoFrame>,
				width: "6.1%",
				height: "7.4%",
				left: "69.5%",
				top: "53%",
			},
			{
				gameRule: "exhibition-chat-sentinel",
				label: "Chat With SentinelOne",
				gaAction: "SentinelOne",
				width: "4.5%",
				height: "8.8%",
				left: "63.5%",
				top: "47.1%",
				CometChatID: "sentinelone",
			},
			{
				gameRule: "exhibition-download-sentinel",
				label: "Successful Threat Hunting",
				gaAction: "SentinelOne",
				href: "https://assets.swoogo.com/uploads/1407887-6167244724e32.pdf",
				isExternal: true,
				target: "_blank",
				width: "8.9%",
				height: "12.1%",
				left: "67.2%",
				top: "66.3%",
			},
			{
				gameRule: "exhibition-download-sentinel-2",
				label: "Autonomous Ai Platforms",
				gaAction: "SentinelOne",
				href: "https://assets.swoogo.com/uploads/1407895-6167249a605e9.pdf",
				isExternal: true,
				target: "_blank",
				width: "5.7%",
				height: "13.0%",
				left: "86.3%",
				top: "68.0%",
			}
		],
		name: "exhibition-hall-gold",
	},
	{
		background: "https://assets.swoogo.com/uploads/full/1411725-6168e10f91d65.jpg",
		links: [
			...(isMember ?
				[{
					display: "none",
					label: "Leaderboard",
					modal: <ModalWrapper>
						<iframe style="width: 30vw; height: 35vh; border: none;" src="https://sponsor-gamification.herokuapp.com/leaderboard?eventId=41082&registrantId=10457086&swoogoAccess=false" />
					</ModalWrapper>
				}] : []
			),
			{
				label: "Previous Room",
				href: "/exhibition-hall-gold",
				width: "17%",
				height: "8.0%",
				left: "23.3%",
				top: "89.0%",
			},
			{
				label: "Next Room",
				href: "/exhibition-hall-diamond",
				width: "17.0%",
				height: "8%",
				left: "58.9%",
				top: "89.6%",
			},
			{
				label: "Back To Main Hall",
				href: "/exhibition-hall",
				width: "18.2%",
				height: "8%",
				left: "40.8%",
				top: "89.3%",
			},
			{
				label: "Tessian Logo",
				gaAction: "Tessian",
				width: "16.5%",
				height: "6.5%",
				left: "4.1%",
				top: "14.1%",
				modal: <SponsorModal sponsorID="181231/tessian" />,
				modalOverrides: {
					dismissStyle: {
						top: "30px",
						padding: "10px 20px",
					},
				}
			},
			{
				gameRule: "exhibition-video-tessian",
				label: "Tessian Video",
				gaAction: "Tessian",
				width: "6.5%",
				height: "7.6%",
				left: "9.6%",
				top: "20.4%",
				modal: <VimeoFrame
					vidId="617104316?h=61651297d3&autoplay=1"
				></VimeoFrame>
			},
			{
				gameRule: "exhibition-chat-tessian",
				label: "Chat With Tessian",
				gaAction: "Tessian",
				href: "",
				width: "5.2%",
				height: "13%",
				left: "0.1%",
				top: "10.9%",
				CometChatID: "tessian",
			},
			{
				gameRule: "exhibition-download-tessian",
				label: "Tessian Resources",
				gaAction: "Tessian",
				isExternal: true,
				target: "_blank",
				href: "https://www.tessian.com/resources/?utm_medium=sponsor&utm_source=isf&utm_campaign=isfdigitalcongress",
				width: "4.9%",
				height: "10.4%",
				left: "3.7%",
				top: "29.7%",
			},
			{
				label: "OneTrust Logo",
				gaAction: "OneTrust",
				width: "13.5%",
				height: "8.4%",
				left: "27.7%",
				top: "12.3%",
				modal: <SponsorModal sponsorID="181229/onetrust" />,
				modalOverrides: {
					dismissStyle: {
						top: "30px",
						padding: "10px 20px",
					},
				}
			},
			{
				gameRule: "exhibition-video-onetrust",
				label: "OneTrust Video",
				gaAction: "OneTrust",
				modal: <VimeoFrame
					vidId="617093262?h=b6555a95c5&autoplay=1"
				></VimeoFrame>,
				width: "6.2%",
				height: "7.7%",
				left: "30.6%",
				top: "20.9%",
			},
			{
				gameRule: "exhibition-chat-onetrust",
				label: "Chat With OneTrust",
				gaAction: "OneTrust",
				href: "",
				width: "5.6%",
				height: "9.8%",
				left: "22.1%",
				top: "11.1%",
				CometChatUserID: "11513669",
			},
			{
				gameRule: "exhibition-onetrust-download",
				label: "OneTrust Download",
				gaAction: "OneTrust",
				href: "https://assets.swoogo.com/uploads/1408030-61672d74305d5.pdf",
				isExternal: true,
				target: "_blank",
				width: "4.9%",
				height: "9.7%",
				left: "25.6%",
				top: "29.9%",
			},
			{
				label: "ImmuniWeb Logo",
				gaAction: "ImmuniWeb",
				width: "9.0%",
				height: "5.8%",
				left: "48.3%",
				top: "8.3%",
				modal: <SponsorModal sponsorID="181233/immuniweb" />,
				modalOverrides: {
					dismissStyle: {
						top: "30px",
						padding: "10px 20px",
					},
				}
			},
			{
				gameRule: "exhibition-video-immuniweb",
				label: "ImmuniWeb Video",
				gaAction: "ImmuniWeb",
				modal: <VimeoFrame
					vidId="617088520?h=74e756f9e5&autoplay=1"
				></VimeoFrame>,
				width: "5.2%",
				height: "6.5%",
				left: "50.3%",
				top: "14.3%"
			},
			{
				gameRule: "exhibition-chat-immuniweb",
				label: "Chat With ImmuniWeb",
				gaAction: "ImmuniWeb",
				href: "",
				width: "6.7%",
				height: "12.7%",
				left: "41.8%",
				top: "6.7%",
				CometChatID: "immuniWeb",
			},
			{
				gameRule: "exhibition-download-immuniweb",
				label: "ImmuniWeb Presentation",
				gaAction: "ImmuniWeb",
				href: "https://assets.swoogo.com/uploads/1408066-61672edc79c9c.pdf",
				isExternal: true,
				target: "_blank",
				width: "4.8%",
				height: "10%",
				left: "43.7%",
				top: "20.6%",
			},
			{
				label: "Keysight Technologies Logo",
				gaAction: "Keysight Technologies",
				width: "10.9%",
				height: "6.2%",
				left: "62.9%",
				top: "13.9%",
				modal: <SponsorModal sponsorID="181230/keysight-technologies" />,
				modalOverrides: {
					dismissStyle: {
						top: "30px",
						padding: "10px 20px",
					},
				}
			},
			{
				gameRule: "exhibition-video-keysight",
				label: "Keysight Technologies Video",
				gaAction: "Keysight Technologies",
				modal: <VimeoFrame
					vidId="620035293?h=504f29e95f&autoplay=1"
				></VimeoFrame>,
				width: "6.7%",
				height: "8.1%",
				left: "65.0%",
				top: "20.4%",
			},
			{
				gameRule: "exhibition-chat-keysight",
				label: "Chat With Keysight Technologies",
				gaAction: "Keysight Technologies",
				href: "",
				width: "5.0%",
				height: "9.5%",
				left: "57.9%",
				top: "10.9%",
				CometChatID: "keysight",

			},
			{
				gameRule: "exhibition-download-keysight",
				label: "Keysight Technologies Download",
				gaAction: "Keysight Technologies",
				href: "https://assets.swoogo.com/uploads/1408012-61672c318e050.pdf",
				isExternal: true,
				target: "_blank",
				width: "5.2%",
				height: "10.0%",
				left: "60.4%",
				top: "29.2%",
			},
			{
				label: "Crossword Cybersecurity Logo",
				gaAction: "Crossword Cybersecurity",
				width: "14.7%",
				height: "8.6%",
				left: "82.8%",
				top: "11.8%",
				modal: <SponsorModal sponsorID="181232/crossword-cybersecurity" />,
				modalOverrides: {
					dismissStyle: {
						top: "30px",
						padding: "10px 20px",
					},
				}
			},
			{
				gameRule: "exhibition-video-crossword",
				label: "Crossword Cybersecurity Video",
				gaAction: "Crossword Cybersecurity",
				modal: <VimeoFrame
					vidId="617046480?h=cfd965157c&autoplay=1"
				></VimeoFrame>,
				width: "6.8%",
				height: "7.6%",
				left: "85.9%",
				top: "20.7%",
			},
			{
				gameRule: "exhibition-chat-crossword",
				label: "Chat With Crossword Cybersecurity",
				gaAction: "Crossword Cybersecurity",
				href: "",
				width: "5.4%",
				height: "12%",
				left: "77.3%",
				top: "9.5%",
				CometChatID: "crosswordcybersecurity",
			},
			{
				gameRule: "exhibition-download-crossword",
				label: "Crossword Cybersecurity Download",
				gaAction: "Crossword Cybersecurity",
				href: "https://assets.swoogo.com/uploads/1408043-61672df04fa98.pdf",
				isExternal: true,
				target: "_blank",
				width: "5.4%",
				height: "10.0%",
				left: "80.4%",
				top: "29.9%",
			},
			{
				label: "Synopsys Logo",
				gaAction: "Synopsys",
				width: "18.2%",
				height: "9.1%",
				left: "12.8%",
				top: "45.2%",
				modal: <SponsorModal sponsorID="181227/synopsys" />,
				modalOverrides: {
					dismissStyle: {
						top: "30px",
						padding: "10px 20px",
					},
				}
			},
			{
				gameRule: "exhibition-vido-synopsys",
				label: "Synopsys Video",
				gaAction: "Synopsys",
				modal: <VimeoFrame
					vidId="617102402?h=73f0d61abb&autoplay=1"
				></VimeoFrame>,
				width: "7.5%",
				height: "9.0%",
				left: "17.9%",
				top: "54.3%",
			},
			{
				gameRule: "exhibition-chat-synopsys",
				label: "Chat with Synopsys",
				gaAction: "Synopsys",
				href: "",
				width: "5.7%",
				height: "9.5%",
				left: "6.8%",
				top: "44.6%",
				CometChatID: "synopsys",
			},
			{
				gameRule: "exhibition-download-synopsys",
				label: "Synopsys - BSIMM Datasheet",
				gaAction: "Synopsys",
				href: "https://assets.swoogo.com/uploads/1408019-61672cd25caf1.pdf",
				isExternal: true,
				target: "_blank",
				width: "6.5%",
				height: "13.0%",
				left: "10.6%",
				top: "67.5%",
			},
			{
				gameRule: "exhibition-download-synopsys-2",
				label: "Synopsys - Software Integrity Portfolio",
				gaAction: "Synopsys",
				href: "https://assets.swoogo.com/uploads/1411965-61694f6430283.pdf",
				isExternal: true,
				target: "_blank",
				width: "5.9%",
				height: "13.0%",
				left: "25.7%",
				top: "66.4%",
			},
			{
				label: "Veracode Logo",
				gaAction: "Veracode",
				width: "17.0%",
				height: "8.8%",
				left: "41.8%",
				top: "45.0%",
				modal: <SponsorModal sponsorID="181226/veracode" />,
				modalOverrides: {
					dismissStyle: {
						top: "30px",
						padding: "10px 20px",
					},
				}
			},
			{
				gameRule: "exhibition-video-veracode",
				label: "Veracode Video",
				gaAction: "Veracode",
				modal: <YouTube
					vidId="6Fq_UMgwX4I?autoplay=1"
				></YouTube>,
				width: "7.3%",
				height: "8.4%",
				left: "46.3%",
				top: "53.6%",
			},
			{
				gameRule: "exhibition-chat-veracode",
				label: "Chat with Veracode",
				gaAction: "Veracode",
				href: "",
				width: "5.7%",
				height: "10.5%",
				left: "35.9%",
				top: "43.6%",
				CometChatUserID: "12448704",
			},
			{
				gameRule: "exhibition-download-veracode",
				label: "Download InfoSheet",
				gaAction: "Veracode",
				href: "https://assets.swoogo.com/uploads/1408038-61672d9be7bdb.pdf",
				isExternal: true,
				target: "_blank",
				width: "7.2%",
				height: "14.1%",
				left: "39.4%",
				top: "65.6%",
			},
			{
				gameRule: "exhibition-download-veracode-2",
				label: "APPSEC Resources And Insights",
				gaAction: "Veracode",
				href: "https://www.veracode.com/events/isf-digital-congress",
				isExternal: true,
				target: "_blank",
				width: "6.5%",
				height: "14.1%",
				left: "53.6%",
				top: "65.7%",
			},
			{
				label: "CrowdStrike Logo",
				gaAction: "CrowdStrike",
				width: "18.2%",
				height: "10.2%",
				left: "69.1%",
				top: "44.3%",
				modal: <SponsorModal sponsorID="181228/crowdstrike" />,
				modalOverrides: {
					dismissStyle: {
						top: "30px",
						padding: "10px 20px",
					},
				}
			},
			{
				gameRule: "exhibition-chat-crowdstrike",
				label: "Chat With CrowdStrike",
				gaAction: "CrowdStrike",
				href: "",
				width: "4.7%",
				height: "9.1%",
				left: "64.0%",
				top: "44.1%",
				CometChatUserID: "12448643",
			},
			{
				gameRule: "exhibition-video-crowdstrike",
				label: "CrowdStrike Video",
				gaAction: "CrowdStrike",
				modal: <VimeoFrame
					vidId="617054803?h=e1d6b5e006&autoplay=1"
				></VimeoFrame>,
				width: "7.6%",
				height: "8.6%",
				left: "73.8%",
				top: "53.8%",
			},
			{
				gameRule: "exhibition-download-crowdstrike",
				label: "Report 2021 GTR",
				gaAction: "Crowdstrike",
				href: "https://assets.swoogo.com/uploads/1408048-61672e21f1364.pdf",
				isExternal: true,
				target: "_blank",
				width: "6.3%",
				height: "13.5%",
				left: "67.8%",
				top: "65.9%",
			},
			{
				gameRule: "exhibition-download-crowdstrike-2",
				label: "White Paper",
				gaAction: "CrowdStrike",
				href: "https://assets.swoogo.com/uploads/1408055-61672e644e7cf.pdf",
				isExternal: true,
				target: "_blank",
				width: "6.1%",
				height: "13.7%",
				left: "81.9%",
				top: "66.8%",
			}
		],
		name: "exhibition-hall-silver",
	},
	{
		background: "https://assets.swoogo.com/uploads/full/1386563-615763db46b1e.jpg",
		links: [
			...(isMember ?
				[{
					display: "none",
					label: "Leaderboard",
					modal: <ModalWrapper>
						<iframe style="width: 30vw; height: 35vh; border: none;" src="https://sponsor-gamification.herokuapp.com/leaderboard?eventId=41082&registrantId=10457086&swoogoAccess=false" />
					</ModalWrapper>
				}] : []
			),
			{
				label: "ISF",
				href: "/isf-speakers",
				width: "8.7%",
				height: "8.7%",
				left: "2.3%",
				top: "69.7%",
			},
			{
				label: "Brian Cox",
				width: "17%",
				height: "46%",
				left: "2.2%",
				top: "20.9%",
				modal: <VimeoFrame
					vidId="621813423?h=75db7307c4&autoplay=1">
				</VimeoFrame>
			},
			{
				label: "Max Mckeown",
				width: "14.6%",
				height: "38.7%",
				left: "20.1%",
				top: "25.1%",
				modal: <VimeoFrame
					vidId="621815982?h=2db5093369&autoplay=1">
				</VimeoFrame>
			},
			{
				label: "Rachel Botsman",
				gaAction: "",
				width: "13.8%",
				height: "35.2%",
				left: "35.7%",
				top: "27.4%",
				modal: <VimeoFrame
					vidId="621815121?h=009f5bf1d9&autoplay=1">
				</VimeoFrame>
			},
			{
				label: "Sadie Creese",
				width: "13.7%",
				height: "34.6%",
				left: "50.3%",
				top: "27.5%",
				modal: <VimeoFrame
					vidId="621815589?h=0d003163e0&autoplay=1">
				</VimeoFrame>
			},
			{
				label: "Steve Wozniak",
				width: "14.9%",
				height: "38.9%",
				left: "64.9%",
				top: "24.9%",
				modal: <VimeoFrame
					vidId="629262645?h=8d77d497e3&autoplay=1">
				</VimeoFrame>
			},
			{
				label: "Viviane Reding",
				width: "16.9%",
				height: "45.2%",
				left: "80.5%",
				top: "20.8%",
				modal: <VimeoFrame
					vidId="621814231?h=e457c89e16&autoplay=1">
				</VimeoFrame>
			},
			{
				label: "Members",
				href: "/member-speakers",
				width: "14.8%",
				height: "10.5%",
				left: "82.2%",
				top: "68.5%",
			},
		],
		name: "speaker-gallery",
		extras: <DisplayOnce id="speakergallery-welcome">
			<ModalWrapper><p style={{ color: "white" }}>Click on a frame to hear from these speakers</p></ModalWrapper>
		</DisplayOnce>
	},
	roomSources.isfSpeakers,
	roomSources.memberSpeakers,
	roomSources.sponsorSpeakers,
	roomSources.auditorium,
	roomSources.explorationZone,
]

const popups = [
	{
		ID: "53553345-f781-4bbd-84f7-1259183467d5",
		trigger: "exploration-threat-crypto",
	},
	{
		ID: "67063d50-66ef-4f8d-92ce-efe9054926a9",
		trigger: "exploration-threat-hacktivists",
	},
	{
		ID: "b3682b8b-dec6-4f03-8f7b-43501cdb4a43",
		trigger: "exploration-threat-polluted",
	},
	{
		ID: "bcba426d-82cc-44c2-a925-7619143ed749",
		trigger: "exploration-threat-virtual",
	},
	{
		ID: "b3cec46e-2ad8-45db-a7ef-9238a3b7a765",
		trigger: "exploration-threat-cloudy",
	},
	{
		ID: "f20686f9-49a8-4bb0-a1b5-d38bdf282062",
		trigger: "exploration-threat-biased",
	},
	{
		ID: "51e33614-6e64-42f2-8980-2d7c4379ec2c",
		trigger: "exploration-threat-soc",
	},
	{
		ID: "2b276c75-0bd7-49e5-8bed-10b71ff7b81d",
		trigger: "exploration-threat-coding",
	},
	{
		ID: "7c32bf0b-b14d-4389-99fc-c665ecb7efc3",
		trigger: "exploration-threat-ransoms",
	},
	{
		ID: "079011ed-eed2-4540-a1f3-94a3ba7c5a6d",
		trigger: "isf-2021-prize-submit",
	},
	{
		ID: "8ed9d794-fe78-4af0-b487-3d0863a10143",
		label: "Lobby welcome popup",
	},
	{
		ID: "d9ee5ab7-d61a-4341-ac11-549a9a486f7f",
		label: "How to Earn Points",
	},
	{
		ID: "4b34d05e-99c2-4311-9d36-02c054a368de",
		trigger: "lounge-connect-4",
	},
	{
		ID: "3af98254-2695-43d8-aa50-42100489653b",
		trigger: "lounge-pacman",
	},
	{
		ID: "ff4f4358-1580-4248-9e43-ba08733e98de",
		trigger: "lounge-memory",
	},
]

const handleNewRoute = ({ previous, url }) => {
	if (
		window.dataLayer[0]["Registrant Type"] === "Non-Member"
		&& !["/atrium", "/breakout-four", "/auditorium", "/breakouts", "/sponsor-theatre"].includes(url)
		&& !url.match(/exhibition-hall/)
	) {
		route(previous || "/atrium")
	}
	// JS time works in milliseconds so for a 2h timeout we need:
	// 1000 ms per second * 3600 s per hour * 2 hours
	if (window.lastPageLoad && window.lastPageLoad < new Date() - 1000 * 3600 * 2) {
		window.location = "https://isfcongress.tkeventsregistration.com/digital2021"
		route(previoous)
	}
	window.lastPageLoad = new Date()
	trackEvent({
		eventID: 41082,
		from: previous?.replace(/^\//g, "").replace(/^$/g, "atrium") || null,
		to: url.replace(/^\//g, "").replace(/^$/g, "atrium"),
		type: "Venue Navigation",
		userID: window.dataLayer[0]["Registrant ID"],
	})
}

render(
	<>
		{popups.map(ElfsightPopup)}
		<script src="https://apps.elfsight.com/p/platform.js" />
		<Navbar />
		{window.dataLayer[0]["I would like to opt in to the Leaderboard competition"] === "Yes" ? <Leaderboard /> : null}
		<Router history={createHashHistory()} onChange={handleNewRoute}>
			{rooms.map(room => <Room {...room} path={room.path || room.name.replace(/ /g, "-").replace(/[^A-z-]/g, "")} />)}
		</Router>
		{window.dataLayer[0]["I would like to opt-in to the Attendee Chat on the Digital Platform"] === "Yes" ? <CometChat /> :
			(
				<div style="position: fixed; height: 60px; right: 20px; bottom: 20px; width: 60px;">
					<MappedImage imageURL="https://widget-js.cometchat.io/v2/resources/chat_bubble.svg" imageStyle="width: 100%; background-color: #FFDD3A; border-radius: 50%; z-index: 100; cursor: pointer; box-shadow: rgba(0, 0, 0, 0.06) 0px 1px 6px 0px, rgba(0, 0, 0, 0.16) 0px 2px 32px 0px;"
						links={[{
							height: "100%",
							left: "0%",
							width: "100%",
							top: "0%",
							modal: <ModalWrapper>
								<div style="display: flex; flex-direction: column; justify-content: space-around; width: 600px; height: 130px; color: white;">
									<h1 style="font-size: 28px; margin: 0;">Want to Participate in the Networking Chat?</h1>
									<p style="font-size: 16px;">You are not opted-in to the networking chat feature. To opt-in, please modify the networking page of your registration <a href="https://isfcongress.tkeventsregistration.com/digital2021">here.</a>
									</p>
								</div>
							</ModalWrapper>
						}]}
					/>
				</div>
			)}
	</>,
	document.getElementById("content"),
)